// extracted by mini-css-extract-plugin
module.exports = {"adminContainer":"Admin_adminContainer__2FkpC","header":"Admin_header__3FK57","title":"Admin_title__zyL7o","titleDiv":"Admin_titleDiv__1RMnW","subHeader":"Admin_subHeader__22Sv1"};